export default {
    setShow (state, payload) {
        state.show = payload
    },
    setMessage (state, payload) {
        state.message = payload
    }
}



// WEBPACK FOOTER //
// ./src/shared/modules/Loading/vuex/mutations.js